import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useDynamicPageFiltersStore = defineStore('dynamicPageFilters', () => {
  const dynamicPagesFilters = ref({
    directories: [],
    scores_schedules: [],
    live_feeds: [],
    articles: [],
    dining: [],
  });

  const getStaffPageFilters = computed(() => dynamicPagesFilters.value.directories);
  const getAthleticsPageFilters = computed(() => dynamicPagesFilters.value.scores_schedules);
  const getLiveFeedPageFilters = computed(() => dynamicPagesFilters.value.live_feeds);
  const getNewsPageFilters = computed(() => dynamicPagesFilters.value.articles);
  const getDiningPageFilters = computed(() => dynamicPagesFilters.value.dining);

  function getCustomSectionFilters({ type }) {
    return dynamicPagesFilters.value[type];
  }

  function setDynamicPageFilters({ type, filters }) {
    dynamicPagesFilters.value[type] = filters;
  }

  return {
    // State
    dynamicPagesFilters,
    // Getters
    getStaffPageFilters,
    getAthleticsPageFilters,
    getLiveFeedPageFilters,
    getNewsPageFilters,
    getDiningPageFilters,
    getCustomSectionFilters,
    // Actions
    setDynamicPageFilters,
  };
});
